var map = {
	"./bank-slip.jpg": "a94b",
	"./bg-footer.png": "fff2",
	"./boletos-banner.jpg": "6480",
	"./checkpoint-banner.jpg": "3d1a",
	"./credit-card.jpg": "4fdd",
	"./dgo-banner.jpg": "d4cc",
	"./drawer-img-02.jpg": "5ca6",
	"./logo-community-ware.png": "274e",
	"./logo-icon.png": "173c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c588";